class Faq {
    constructor(element) {
        this.container = element;
        this.faqs = [...element.querySelectorAll('[data-faq]')];
        this.questions = [...element.querySelectorAll('[data-faq-question]')];
        this.answers = [...element.querySelectorAll('[data-faq-answer]')];
    }

    init = () => {
        this.cycleThroughQuestions(this.container);

        this.faqs.forEach((faq, index) => {
            this.toggleOnClickQuestion(index);
        });
    };

    toggleOnClickQuestion = (index) => {
        const question = this.questions[index];

        question.addEventListener('click', () => {
            const isExpanded = question.getAttribute('aria-expanded') === 'true';

            (isExpanded ? this.closeQuestion : this.openQuestion)(index);
        });
    }

    openQuestion = (index) => {
        const faq = this.faqs[index];
        const question = this.questions[index];
        const answer = this.answers[index];

        faq.classList.add('is-active');
        question.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
    }

    closeQuestion = (index) => {
        const faq = this.faqs[index];
        const question = this.questions[index];
        const answer = this.answers[index];

        faq.classList.remove('is-active');
        question.setAttribute('aria-expanded', 'false');
        answer.setAttribute('hidden', '');
    }

    cycleThroughQuestions = (container) => {
        container.addEventListener('keydown', (event) => {
            const {
                target,
            } = event;

            const key = event.which || event.keyCode;

            if (container.contains(target)) {
                if (key === 38 || key === 40) {
                    // 38 = up, go to previous question
                    // 40 = down, go to next question

                    const index = this.questions.indexOf(target);
                    const direction = (key === 40) ? 1 : -1;
                    const {
                        length,
                    } = this.questions;
                    const newIndex = (index + length + direction) % length;

                    this.questions[newIndex].focus();

                    event.preventDefault();
                } else if (key === 36) {
                    // 36 = home, focus on first question
                    this.questions[0].focus();
                    event.preventDefault();
                } else if (key === 35) {
                    // 35 = end, focus on last question
                    this.questions[this.questions.length - 1].focus();

                    event.preventDefault();
                }
            }
        });
    }
}

export default Faq;
